module.exports = __webpack_public_path__ + "static/media/heliLowerStraight.cd1787e0.png";